<template>
  <relation type="info" />
</template>
<script>
import Relation from './relation/Relation'
export default {
  components: {
    Relation
  }
}
</script>
